import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { TYPE_SORT, TYPE_SORT_FOLLOWING_LIST } from '../../../constant'
import { handleSelectAllIdInTable } from '../../../helper'
import { PERFORMANCE_SCORE_COLOR, SCORE_TYPE } from '../constant'
import { convertDataTableRedux, getListId } from '../helper'
import {
  downloadFilteredCompanies,
  getAllIdCompanyFilter,
  getFilteredCompanies,
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from './thunk'

const initialState = {
  dataReduxTable: {},
  ids: [],
  selectCheckBox: {
    listIdsSelected: {},
    listIdAllByTerm: [],
  },
  isLoading: {
    getFilteredCompanies: false,
    download: false,
    getAllIdOrg: true,
  },
  filter: {
    term: '',
    page: 1,
    pageSize: 20,
    sort: TYPE_SORT_FOLLOWING_LIST.DELIVERY_DATE_ID,
    sortDirection: TYPE_SORT.DESCENDING,
  },
  totalRecords: 0,
  scoreRanges: {
    [SCORE_TYPE.CREDIT_RISK]: [],
    [SCORE_TYPE.PERFORMANCE]: [],
  },
  isOpenFilter: false,
}

const slice = createSlice({
  name: 'library/filterCompanies',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeCheckboxTable: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.selectCheckBox, path, data)
    },
    selectAllIdInTable: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.ids,
        action.payload,
      )
    },
    selectAllIdByTerm: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.selectCheckBox.listIdAllByTerm,
        action.payload,
      )
    },
    unSelectAllCheckbox: (state) => {
      state.selectCheckBox.listIdsSelected = {}
    },
    setOpenFilter: (state) => {
      state.isOpenFilter = !state.isOpenFilter
    },
  },

  extraReducers: (builder) => {
    //getFilteredCompanies
    builder.addCase(getFilteredCompanies.pending, (state) => {
      state.isLoading.getFilteredCompanies = true
    })

    builder.addCase(getFilteredCompanies.fulfilled, (state, action) => {
      state.filter = {
        ...state.filter,
        term: action.meta.arg?.term,
      }
      state.totalRecords = action.payload.totalRecords
      state.ids = getListId(action.payload.data)
      state.dataReduxTable = convertDataTableRedux(action.payload.data)
      state.isLoading.getFilteredCompanies = false
    })

    builder.addCase(getFilteredCompanies.rejected, (state, action) => {
      state.dataReduxTable = {}
      state.ids = []
      state.totalRecords = 0
      state.isLoading.getFilteredCompanies = action.payload.loading
    })

    //getScoreRangesCreditRisk
    builder.addCase(getScoreRangesCreditRisk.fulfilled, (state, action) => {
      state.scoreRanges[SCORE_TYPE.CREDIT_RISK] = [...action.payload]
        .reverse()
        .map((item, index) => ({
          ...item,
          color: item.scoreRangeCode,
        }))
    })
    //getScoreRangesPerformance
    builder.addCase(getScoreRangesPerformance.fulfilled, (state, action) => {
      state.scoreRanges[SCORE_TYPE.PERFORMANCE] = [...action.payload]
        .reverse()
        .map((item, index) => ({
          ...item,
          color: PERFORMANCE_SCORE_COLOR[index],
        }))
    })
    //downloadFilteredCompanies
    builder.addCase(downloadFilteredCompanies.pending, (state) => {
      state.isLoading.download = true
    })
    builder.addCase(downloadFilteredCompanies.fulfilled, (state, action) => {
      state.isLoading.download = false
    })
    builder.addCase(downloadFilteredCompanies.rejected, (state, action) => {
      state.isLoading.download = action.payload.loading
    })
    //getAllIdCompanyFilter
    builder.addCase(getAllIdCompanyFilter.pending, (state) => {
      state.isLoading.getAllIdOrg = true
    })
    builder.addCase(getAllIdCompanyFilter.fulfilled, (state, action) => {
      state.selectCheckBox.listIdAllByTerm = action.payload
      state.isLoading.getAllIdOrg = false
    })
    builder.addCase(getAllIdCompanyFilter.rejected, (state, action) => {
      state.isLoading.getAllIdOrg = action.payload.loading
    })
  },
})

//getFilteredCompanies
export const selectIds = (state) => state[slice.name].ids
export const selectDataTable = (rowId, colId) => (state) => {
  return state[slice.name].dataReduxTable[rowId][colId]
}
export const getDataTableByRowId = (rowId) => (state) => {
  return state[slice.name].dataReduxTable[rowId]
}

//checkbox Table
export const selectDataCheckBox = (type) => (state) =>
  state[slice.name].selectCheckBox[type]

export const selectCheckboxFilter =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce(
      (result, key) => result[key],
      state[slice.name].selectCheckBox,
    )
    return callback ? callback(data) : data
  }

//select Loading
export const selectLoading = (type) => (state) => {
  return type ? state[slice.name].isLoading[type] : state[slice.name].isLoading
}

//get filter
export const selectFilterTableFilterCompany = (type) => (state) =>
  type ? state[slice.name].filter[type] : state[slice.name].filter
export const selectTotalRecords = (state) => state[slice.name].totalRecords

//get Range Score
export const selectScoreRanges = (scoreType, callback) => (state) => {
  const data = state[slice.name].scoreRanges[scoreType]
  return callback ? callback(data) : data
}

export const getOpenFilter = (state) => state[slice.name].isOpenFilter

export const {
  resetStore,
  changeFilter,
  changeCheckboxTable,
  selectAllIdInTable,
  selectAllIdByTerm,
  unSelectAllCheckbox,
  setOpenFilter,
} = slice.actions

register(slice.name, slice.reducer)
